import React, { useState, useRef, useEffect } from 'react';
import './TestimonialsSection.css';
import API_URL from '../../apiConfig';

const TestimonialsSection = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const trackRef = useRef(null);

    useEffect(() => {
        const fetchTestis = async () => {
            try {
                const res = await fetch(`${API_URL}/api/temoignages/all`);
                const data = await res.json();
                if (data.success && data.temoignages.length > 0) {
                    setTestimonials(data.temoignages);
                }
            } catch (err) {
                console.error("Erreur chargement témoignages:", err);
            }
        };
        fetchTestis();
    }, []);

    // Si aucun témoignage n'est chargé, on ne rend rien ou un message vide
    if (testimonials.length === 0) return null;

    /* Sync dot avec scroll mobile */
    const handleMobileScroll = () => {
        if (!trackRef.current) return;
        const card = trackRef.current.querySelector('.testi-card-mobile');
        if (!card) return;
        const idx = Math.round(trackRef.current.scrollLeft / (card.offsetWidth + 16));
        setActiveIndex(idx);
    };

    return (
        <section className="testimonials-section py-5" id="temoignages">
            <div className="container py-lg-5">

                {/* En-tête */}
                <div className="text-center mb-5">
                    <span className="testi-label text-uppercase fw-bold small mb-2 d-block">Ce qu'ils disent</span>
                    <h2 className="outfit fs-1 fw-bold text-dark mb-3">Témoignages</h2>
                    <p className="text-muted mx-auto" style={{ maxWidth: '550px', fontSize: '0.95rem' }}>
                        Des vies transformées par la Parole de Dieu. Voici ce que nos membres partagent.
                    </p>
                </div>

                {/* ── Grille desktop (md+) ── */}
                <div className="row g-4 mb-4 d-none d-md-flex">
                    {testimonials.map((t, idx) => (
                        <div key={t.id_tem} className="col-md-6 col-lg-3">
                            <div
                                className={`testi-card h-100 ${idx === activeIndex ? 'testi-card-active' : ''}`}
                                onClick={() => setActiveIndex(idx)}
                            >
                                <div className="testi-quote-icon mb-3"><i className="bi bi-quote"></i></div>
                                <div className="testi-stars mb-3">
                                    {[...Array(t.stars)].map((_, i) => <i key={i} className="bi bi-star-fill"></i>)}
                                </div>
                                <p className="testi-text mb-4">"{t.message}"</p>
                                <div className="testi-author d-flex align-items-center gap-3 mt-auto">
                                    <div className="testi-avatar" style={{ background: `linear-gradient(135deg, ${t.color} 0%, ${t.color}99 100%)` }}>
                                        {t.initials}
                                    </div>
                                    <div>
                                        <p className="testi-author-name mb-0">{t.nom}</p>
                                        <p className="testi-author-role mb-0">{t.role}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* ── Carousel mobile 1.5 (< md) ── */}
                <div className="d-md-none mb-4 position-relative">
                    <div
                        className="testi-mobile-track"
                        ref={trackRef}
                        onScroll={handleMobileScroll}
                    >
                        {testimonials.map((t, idx) => (
                            <div key={t.id_tem} className="testi-card testi-card-mobile border-0">
                                <div className="testi-quote-icon mb-3"><i className="bi bi-quote"></i></div>
                                <div className="testi-stars mb-3">
                                    {[...Array(t.stars)].map((_, i) => <i key={i} className="bi bi-star-fill"></i>)}
                                </div>
                                <p className="testi-text mb-4">"{t.message}"</p>
                                <div className="testi-author d-flex align-items-center gap-3 mt-auto">
                                    <div className="testi-avatar" style={{ background: `linear-gradient(135deg, ${t.color} 0%, ${t.color}99 100%)` }}>
                                        {t.initials}
                                    </div>
                                    <div>
                                        <p className="testi-author-name mb-0">{t.nom}</p>
                                        <p className="testi-author-role mb-0">{t.role}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Indicateurs (dots) */}
                <div className="testi-dots d-flex justify-content-center gap-2">
                    {testimonials.map((_, idx) => (
                        <button
                            key={idx}
                            className={`testi-dot ${idx === activeIndex ? 'testi-dot-active' : ''}`}
                            onClick={() => {
                                setActiveIndex(idx);
                                /* scroll mobile vers la bonne carte */
                                if (trackRef.current) {
                                    const card = trackRef.current.querySelector('.testi-card-mobile');
                                    if (card) trackRef.current.scrollTo({ left: idx * (card.offsetWidth + 16), behavior: 'smooth' });
                                }
                            }}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
};

export default TestimonialsSection;
